import { useQuery } from '@apollo/client/react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import ErrorBox from '../../core/components/ErrorBox';
import assert from '../../core/util/assert';
import { bookingStatsQuery, BookingStatsQueryResult } from '../../main/queries';
import BookingHeatmap from './BookingHeatmap';

const StatsMonthly = () => {
    const { loading, error, data } = useQuery<BookingStatsQueryResult>(
        bookingStatsQuery,
        {
            variables: { projected: true },
        }
    );

    if (loading) {
        return (
            <Box display="flex" flexDirection="column" gap={3} p={5}>
                <Skeleton variant="text" height={50} />
                <Skeleton variant="rectangular" height={400} />
            </Box>
        );
    }

    if (error) return <ErrorBox error={error} />;

    assert(data);

    const { bookings } = data.stats;

    const years = Array.from(
        new Set(bookings.map(booking => +booking.checkout.slice(0, 4)))
    );

    years.reverse();

    const bookingsInYears = years.map(
        year =>
            [
                year,
                bookings.filter(booking =>
                    booking.checkout.startsWith(year.toString())
                ),
            ] as const
    );

    return (
        <Box display="flex" flexDirection="row" flexWrap="wrap">
            {bookingsInYears.map(([year, yearBookings]) => (
                <Box
                    key={year}
                    p={5}
                    display="flex"
                    flexDirection="column"
                    gap={4}
                >
                    <BookingHeatmap year={year} bookings={yearBookings} />
                </Box>
            ))}
        </Box>
    );
};

export default StatsMonthly;
